module.exports = __webpack_public_path__ + "images/emoji/unamused.9facbc5d47f20526a6f1.png";